import type { AggregationLevel } from '~/types/new/energy';
import type { Baseline, BaselineData, BaselinePrediction, BaselineVariables } from '../types';

export const baselineStore = defineStore('baselineStore', () => {
  // Baseline model
  const areaId = ref<number | undefined>(undefined);
  const variables = ref<BaselineVariables>([]);
  const hasIntercept = ref<boolean | undefined>(undefined);
  const hasInteractions = ref<boolean | undefined>(undefined);
  const aggregationLevel = ref<AggregationLevel | undefined>(undefined);

  // Baselines list
  const baselines = ref<Baseline[]>([]);
  const loadingBaselinesList = ref<boolean>(true);
  const loadingBaselinesListPerformance = ref<boolean>(true);

  // Baseline
  const baselineLoading = ref<boolean>(true);
  const baseline = ref<Baseline | undefined>(undefined);

  // Baseline data
  const baselineDataLoading = ref<boolean>(true);
  const baselineData = ref<BaselineData | undefined>(undefined);
  const baselineDataError = ref<string | undefined>(undefined);

  // Baseline prediction
  const baselinePredictionLoading = ref<boolean>(true);
  const baselinePredictionError = ref<string | undefined>(undefined);
  const baselinePrediction = ref<BaselinePrediction | undefined>(undefined);

  // Methods
  const clearBaselineData = () => {
    areaId.value = undefined;
    variables.value = [];
    hasIntercept.value = undefined;
    hasInteractions.value = undefined;
    aggregationLevel.value = undefined;
    baseline.value = undefined;
  };

  return {
    areaId,
    hasIntercept,
    hasInteractions,
    aggregationLevel,
    variables,
    baseline,
    baselineData,
    baselines,
    loadingBaselinesList,
    loadingBaselinesListPerformance,
    baselineDataLoading,
    baselineDataError,
    baselinePrediction,
    baselinePredictionLoading,
    baselinePredictionError,
    baselineLoading,
    clearBaselineData,
  };
});
